import * as Yup from "yup";
const validationSchema = Yup.object().shape({
  workspaceName: Yup.string().required(
    "El nombre del espacio de trabajo es requerido"
  ),
  emails: Yup.array().of(
    Yup.string().email("Ingrese una dirección de correo electrónico válida")
  ),
});

export default validationSchema;
